import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, of, timer } from 'rxjs';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.css'],
    standalone: false
})
export class ToastComponent implements OnInit {
  @Input() autohide: boolean;
  @Input() delay: number;
  @Input() className: string;
  @Output() hidden = new EventEmitter<boolean>();

  constructor() { }

    ngOnInit(): void {
        if(this.autohide){
            timer(this.delay)
                .subscribe(() => {
                    this.hidden.emit(true);
            });
        }
    }

}
